export default __webpack_public_path__ + "ae8d2feba230c1b3dec9539d5a710567.ttf";